import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import Button from "../buttons/Button";
const useStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "flex-end",
    },
});
const BasicFooter = ({ onClose }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(Button, { onClick: onClose }, "OK")));
};
export default BasicFooter;
//# sourceMappingURL=Footer.js.map